import API from '@/api/base'

API.define(
  'itemBySlug',
  {
    categorySlug: '',
    itemSlug: '',
    siteSlug: '',
  },
  {
    collectionPath: 'shop_item/slug',
  }
)

export const state = {
  shopItems: [],
  pageTotal: 0,
  perPage: 10,
  currentPage: 1,
}

export const getters = {
  getShopItem: ({ shopItems }) => (itemId) => {
    return shopItems.find((item) => item.id === itemId)
  },
  getShopItems: ({ shopItems }) => shopItems,
  getFilteredItems: ({ shopItems }) => (filter) => shopItems,
  getPerPage: ({ perPage }) => perPage,
  getCurrentPage: ({ currentPage }) => currentPage,
  getPageTotal: ({ pageTotal }) => pageTotal,
}

export const actions = {
  fetchShopItems: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      const requestParams = {
        query: { site_id: params.siteId },
        page: { number: params.currentPage, size: params.perPage },
        sort: params.sort,
      }
      if (params.slug) {
        requestParams.filter = {
          name_cont: params.slug,
          description_cont: params.slug,
          m: 'or',
        }
      }
      if (params.categoryId) {
        requestParams.filter = {
          categoryId: params.categoryId,
        }
      }
      if (params.segment) {
        if (params.segment === 'parents') {
          requestParams.filter = {
            forParents: true,
          }
        }
        if (params.segment === 'catering') {
          requestParams.filter = {
            isCatering: true,
          }
        }
        if (params.segment === 'mingleNosh') {
          requestParams.filter = {
            mingleNosh: true,
          }
        }
      }
      API.findAll('shopItem', requestParams)
        .then((response) => {
          if (response.data !== null) {
            commit('SET_SHOP_ITEMS', response.data)
            const total = response.meta.pagination.last
              ? response.meta.pagination.last
              : response.meta.pagination.current
            commit('SET_PAGE_TOTAL', total)
            commit('SET_CURRENT_PAGE', response.meta.pagination.current)
            resolve(response.data)
          } else {
            commit('SET_SHOP_ITEMS', [])
            commit('SET_PAGE_TOTAL', 1)
            commit('SET_CURRENT_PAGE', 1)
            resolve()
          }
        })
        .catch((error) => {
          reject(error.response)
        })
    }),
  fetchShopItem: ({ commit }, itemId) =>
    new Promise((resolve, reject) => {
      API.find('shopItem', itemId)
        .then((response) => {
          // TODO: Add this to the store
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response)
        })
    }),
  fetchShopItemBySlug: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      API.findAll('itemBySlug', {
        query: {
          item_slug: params.itemSlug,
          site_slug: params.siteSlug,
        },
      })
        .then((response) => {
          // TODO: Add this to the store
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response)
        })
    }),

  resetShopItems: ({ commit }) => {
    commit('SET_SHOP_ITEMS', [])
  },
}

export const mutations = {
  SET_SHOP_ITEMS(state, shopItems) {
    state.shopItems = shopItems
  },
  SET_PAGE_TOTAL(state, total) {
    state.pageTotal = total
  },

  SET_CURRENT_PAGE(state, page) {
    state.currentPage = page
  },
}
